export enum QueryKeys {
  GetAllCategoryVisibility = 'get-all-category-visibility',
}
